function NoMatch() {
  return <p>Wrong url</p>;
}

export default NoMatch;
